import enUS from './resources/en-us';
import jaJP from './resources/ja-jp';

export const resources = { 'en-US': enUS, 'ja-JP': jaJP };
